var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 10.2273C20.0001 9.51825 19.9351 8.83643 19.8145 8.18188H10.2041V12.0501H15.6958C15.4592 13.3001 14.7403 14.3592 13.6596 15.0682V17.5773H16.9574C18.8869 15.8364 20.0001 13.2728 20.0001 10.2273Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2041 19.9999C12.9592 19.9999 15.2691 19.1044 16.9574 17.5772L13.6596 15.0681C12.7459 15.6681 11.577 16.0226 10.2041 16.0226C7.5464 16.0226 5.29685 14.2635 4.49444 11.8999H1.08533V14.4908C2.76437 17.759 6.21522 19.9999 10.2041 19.9999Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49446 11.8997C4.29037 11.2997 4.17442 10.6588 4.17442 9.9997C4.17442 9.34061 4.29037 8.6997 4.49446 8.0997V5.50879H1.08535C0.394251 6.85879 0 8.38606 0 9.9997C0 11.6133 0.394251 13.1406 1.08535 14.4906L4.49446 11.8997Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2041 3.97727C11.7023 3.97727 13.0474 4.48182 14.1049 5.47273L17.0316 2.60455C15.2644 0.990909 12.9546 0 10.2041 0C6.21522 0 2.76437 2.24091 1.08533 5.50909L4.49444 8.1C5.29685 5.73636 7.5464 3.97727 10.2041 3.97727Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.813850ee915ff99c45bb7a3f3a8113b4.svg";
export { ForwardRef as ReactComponent };